<template>
    <section id="dose-dependent-content">
        <div class="container">
            <div class="content">
                <span class="eyebrow-page omnes fw-semibold text-orange">Pharmacokinetic/Pharmacodynamic Model</span>
                <h1 class="gtitle fw-semibold">
                    PK/PD data modeled for dose-dependent duration of effect for JORNAY PM<sup class="omnes">1</sup></h1>
            </div>

            <div class="content py-4">
                <span class="sub-content">
                    In a computer-generated model based on a clinical trial, PK data were collected from 20 healthy adult volunteers (Phase 1 PK study) and efficacy data were collected from 117 children with ADHD (Phase 3 analog classroom study) to determine the effect of dose and evening administration on a modeled clinical benefit. 
                    <b>The modeled data are descriptive in nature and no formal statistical comparisons can be drawn.</b><sup>1-3</sup>
                </span>
            </div>


            <div class="content img-container">
                <p class="pb-4 text-uppercase">Predicted clinical response of JORNAY PM at varying doses <label
                        class="text-lowercase m-0">vs</label> placebo<sup>1,4*</sup></p>
                <div class="my-4">
                    <img class="d-none d-lg-block" src="../../assets/img/dosing/dose-graph.png" alt="dose-graph">
                    <div class="d-block d-lg-none" @mouseleave="restoreZoomIcon" @click="tapIcon">
                        <img v-if="showZoomIcon" src="../../assets/img/dosing/dose-graph-mobile.png"
                            alt="dose-graph" @wheel="hideZoomIcon" class="zoomable-image" />

                        <!-- Image without zoom icon -->
                        <img v-else src="../../assets/img/dosing/dose-graph-mobile-noicon.png"
                            alt="dose-graph" class="zoomable-image" />

                    </div>
                </div>

                <div class="notes ml-2">
                    <p><span class="asterisk">*</span>Each colored line in the graph represents a different dose of JORNAY PM. They demonstrate
                    how the different doses are predicted to deliver various durations of
                    symptom control in a PK/PD model. The lower the line on the SKAMP score, the better control patients
                    have of their ADHD symptoms.</p>
                </div>
                    
            </div>

        </div>


        <div class="content py-5 middle-title p-0">
            <div class="container">
                <div class="middle-title_content ">
                    <h2 class="gtitle text-center fw-bold">With higher doses, JORNAY PM is predicted to last longer into the evening.<sup>1</sup></h2>
                </div>
            </div>

        </div>



        <div class="container">
            <div class="content limitations py-4">
                <div class="col-12 p-0">
                    <label class=""><b>Limitations</b> of PK/PD modeling studies:</label>
                    <ul class="">
                        <li class="mb-1">These data do not represent actual clinical outcomes, they are only predictions, and should be interpreted with caution and with these limitations in mind<sup>1</sup>
                        </li>
                        <li class="mb-1">These data are predicted rather than actual SKAMP scores and differences may exist between actual MPH and predicted SKAMP scores in each group<sup>1</sup></li>
                        <li class="mb-1">Modeled clinical benefit was determined solely on reduction of impairment based on classroom behaviors, as measured by SKAMP, and did not include data on functional impairment outside the classroom or tolerability<sup>1</sup></li>
                        <li class="mb-1">Clinical data were obtained using optimized doses of JORNAY PM, where optimal dosage was defined as dose and administration time producing meaningful symptom control while remaining well tolerated<sup>1</sup></li>
                        <li class="mb-1"><b>No conclusions regarding efficacy or safety can be drawn from these data</b></li>
                    </ul>
                </div>
            </div>

            <div class="footnote">
                <p class="pr-3">MPH=methylphenidate; PD=pharmacodynamic; PK=pharmacokinetic; SKAMP=Swanson, Kotkin, Agler, M-Flynn, and Pelham.</p>
            </div>

            <!-- <div class="content pt-5">
                <div class="d-flex pills-container">
                    <div class="col-3 col-md-2 col-lg-1 d-flex p-0 pl-lg-2">
                        <img src="../../assets/img/dosing/dosing-icon.png" alt="Orange icon of a pill capsule">
                    </div>
                    <div class="col-9 col-lg-9 p-0 pl-2 pl-lg-5">
                        <p class="m-0">Dose may be titrated weekly in <span class="text-nowrap">20-mg/day</span> increments up to a maximum daily dose of 100 mg/day.<sup>4</sup>
                        </p>
                    </div>

                </div>
            </div> -->
        </div>
    </section>
</template>



<script>


export default {
    components: {
    },
    data() {
        return {
            showZoomIcon: true,
            timeoutId: null,
        }
    }, 
    methods: {
        hideZoomIcon() {
            console.log('hideZoomIcon');
            this.showZoomIcon = false;
            clearTimeout(this.timeoutId);
        },
        restoreZoomIcon() {
            this.timeoutId = setTimeout(() => {
                this.showZoomIcon = true;
            }, 500); 
        },
        tapIcon() {
            this.showZoomIcon = false;
        }
    }


}
</script>